import React, { useState, memo, useEffect, Fragment } from 'react';
import { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import { InputAdornment, TextField } from '@material-ui/core';
import useDebounce from 'hooks/useDebounce';

function ColorInput(props) {
  const { color, setColor } = props;
  const {
    readOnly = true,
    showLayerIcon = false,
    name = 'color',
    label = 'Color',
    required = false,
  } = props;
  const [inputColor, setInputColor] = useState(color, 500);
  const colorDebounce = useDebounce(inputColor);

  useEffect(() => {
    setColor(inputColor);
  }, [colorDebounce]);

  return (
    <TextField
      label={label}
      value={inputColor}
      readOnly={readOnly}
      fullWidth
      margin="normal"
      required={required}
      InputProps={{
        startAdornment: (
          <Fragment>
            <InputAdornment position="start">
              <input
                type="color"
                name={name}
                defaultValue={inputColor || ''}
                onChange={(e) => setInputColor(e.target.value)}
              />
            </InputAdornment>
            {showLayerIcon && (
              <InputAdornment position="start">
                <LayerColorIcon layer={{ color: inputColor }} />
              </InputAdornment>
            )}
          </Fragment>
        ),
      }}
    />
  );
}

export default memo(ColorInput, (prevProps, nextProps) => {
  return prevProps.color === nextProps.color;
});
